function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.7122 15.8C58.6323 13.69 55.7985 12.5019 52.8413 12.5H21.1587C15.0113 12.5371 10.037 17.5299 10 23.7V39.8C10.037 45.9701 15.0113 50.9629 21.1587 51H21.5572V47.4H21.1587C16.9768 47.4 13.5867 43.9974 13.5867 39.8V23.7C13.5867 19.5026 16.9768 16.1 21.1587 16.1H52.8413C57.0232 16.1 60.4133 19.5026 60.4133 23.7V39.8C60.4133 43.9974 57.0232 47.4 52.8413 47.4H51.1476V56.7L37.5978 47.4L32.0184 51H36.5018L54.6347 63.5V50.9C60.0215 50.0344 63.988 45.3756 64 39.9V23.7C63.9981 20.7318 62.8144 17.8876 60.7122 15.8Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7491 18.3H50.2509C54.5351 18.3 58.1218 21.6 58.1218 25.6V38C58.1218 42 54.6347 45.3 50.2509 45.3H37L23.7491 53.7V45.3C19.465 45.3 15.8782 42 15.8782 38V25.5C15.8782 21.5 19.3653 18.3 23.7491 18.3Z",
  fill: "#D0E6EE"
});
function SvgLessonChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonChat);
export default __webpack_public_path__ + "static/media/Lesson-chat.85cb064d10dbea53505fc37b06979012.svg";
export { ForwardRef as ReactComponent };